import { useQuery } from 'hooks/useQuery'

import { fetchUsersSearch } from 'utils/queries'

import { UserType } from 'types/user'

interface Props {
  searchTerm: string
}

export const useUserSearch = ({ searchTerm }: Props) => {
  const usersQuery = useQuery<Array<UserType>>(['usersSearch', searchTerm], () => {
    if (!searchTerm || searchTerm.length < 3) {
      return []
    }

    return fetchUsersSearch({ searchTerm })
  })

  return usersQuery
}
